const state = {
  globalLoading: false,
  globalLoadingMessageArray: [],
  snackbar: false,
  snackbarType: '',
  snackbarText: '',
  confirmationDialog: false,
  confirmationDialogConfig: {},
  confirmarDialog: false,
  confirmarDialogConfig: {},
  confirmarDialogPromiseResolve: null,
  confirmarDialogPromiseReject: null,
  informacao: {
    mensagem: '',
    dataValidade: ''
  }
}

export default state



// WEBPACK FOOTER //
// ./src/vuex/ui/state.js